










import { Component, Prop, Vue } from 'vue-property-decorator';
import { ITag, PolicyFilter } from 'admiral-core';
import { PreferencesAction } from '@/store/PreferencesModule';

@Component({
  components: {},
})
export default class PolicyTagLink extends Vue {
  @Prop({ type: Object })
  tag!: ITag;

  @Prop({ type: Boolean, default: () => true })
  isActive!: boolean;

  get filter(): PolicyFilter {
    return this.$store.state.PreferencesModule.policyFilter;
  }

  async handleClick(event: MouseEvent) {
    if (!this.isActive) {
      return false;
    }
    const filter = (await this.$store.getters['PreferencesModule/getPolicyFilter']) as PolicyFilter;
    if ((filter.tags || []).find((tag: ITag) => tag.id === this.tag.id)) {
      filter.tags = [];
    } else {
      filter.tags = [this.tag];
    }
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.setPolicyFilter}`, filter);
  }

  title() {
    if ((this.filter.tags || []).find((tag: ITag) => tag.id === this.tag.id)) {
      return 'Filter entfernen';
    } else {
      return `Filter setzen`;
    }
  }
}
